import { t } from "@/i18n-js/instance";

import { FeatureRow } from "../FeatureRow";
import { SectionWrapper } from "./SectionWrapper";

export const Sso = () => {
  const features = [
    {
      title: t("pricing_plans.feature.facebook"),
      basic: true,
      professional: true,
      business: true,
      enterprise: true,
      plus: true,
    },
    {
      title: t("pricing_plans.feature.twitter"),
      basic: true,
      professional: true,
      business: true,
      enterprise: true,
      plus: true,
    },
    {
      title: t("pricing_plans.feature.memberstack"),
      basic: true,
      professional: true,
      business: true,
      enterprise: true,
      plus: true,
    },
    {
      title: t("pricing_plans.feature.memberspace"),
      basic: true,
      professional: true,
      business: true,
      enterprise: true,
      plus: true,
    },
    {
      title: t("pricing_plans.feature.teachable"),
      basic: true,
      professional: true,
      business: true,
      enterprise: true,
      plus: true,
    },
    {
      title: t("pricing_plans.feature.memberful"),
      basic: false,
      professional: true,
      business: true,
      enterprise: true,
      plus: true,
    },
    {
      title: t("pricing_plans.feature.wordpress"),
      basic: false,
      professional: true,
      business: true,
      enterprise: true,
      plus: true,
    },
    {
      title: t("pricing_plans.feature.bubble"),
      basic: false,
      professional: true,
      business: true,
      enterprise: true,
      plus: true,
    },
    {
      title: t("pricing_plans.feature.outseta"),
      basic: false,
      professional: true,
      business: true,
      enterprise: true,
      plus: true,
    },
    {
      title: t("pricing_plans.feature.auth0"),
      basic: false,
      professional: false,
      business: false,
      enterprise: true,
      plus: true,
    },
    {
      title: t("pricing_plans.feature.custom_oauth"),
      basic: false,
      professional: false,
      business: false,
      enterprise: true,
      plus: true,
    },
  ];

  return (
    <SectionWrapper sectionName={t("pricing_plans.section.sso")}>
      {features.map(feature => (
        <FeatureRow {...feature} key={feature.title} />
      ))}
    </SectionWrapper>
  );
};
